import FourCubes from '../../../components/Icons/FourCubes';
import JobInviteIcon from '../../../components/Icons/JobInviteIcon';
import JobsIcon from '../../../components/Icons/JobsIcon';
import { LocumIcon } from '../../../components/Icons/LocumIcon';
import PlaneIcon from '../../../components/Icons/PlaneIcon';
import ReferralIcon from '../../../components/Icons/ReferralIcon';
import SettingsIcon from '../../../components/Icons/SettingsIcon';
import SubscriptionIcon from '../../../components/Icons/SubscriptionIcon';
import {
  APPLICATION,
  DASHBOARD,
  FIND_LOCUM,
  INVITED_JOBS,
  LOCUMJOBS,
  REFERRALS,
  SUBSCRIPTIONS_PLANS,
  USERS_SETTINGS,
} from '../../../routes/routeConstants';

interface INavConfig {
  title: string;
  path: string;
  icon: React.ReactNode;
}

export const navConfig: INavConfig[] = [
  {
    title: 'Dashboard',
    path: DASHBOARD,
    icon: <FourCubes />,
  },
  {
    title: 'Locum Jobs',
    path: LOCUMJOBS,
    icon: <JobsIcon />,
  },
  {
    title: 'Invited Jobs',
    path: INVITED_JOBS,
    icon: <JobInviteIcon />,
  },
  {
    title: 'Applications',
    path: APPLICATION,
    icon: <PlaneIcon />,
  },
  {
    title: 'Find a Locum',
    path: FIND_LOCUM,
    icon: <LocumIcon />,
  },
  {
    title: 'Referrals',
    path: REFERRALS,
    icon: <ReferralIcon />,
  },
  {
    title: 'Subscription',
    path: SUBSCRIPTIONS_PLANS,
    icon: <SubscriptionIcon />,
  },
  {
    title: 'Settings',
    path: USERS_SETTINGS,
    icon: <SettingsIcon />,
  },
];
